

export default function NotAllowed({}){

    return(
        <p className="font-bold text-center mt-10 w-full">Vous n'avez pas le droit d'accéder à cette page</p>
    )
}